<template>
  <div 
    class="fixed left-1/2 -translate-x-1/2 w-full top-0 z-30 flex justify-center md:mx-auto md:max-w-2xl"
    :style="computedStyle"
  >
    <img 
      :src="asset('img/logo.svg')" 
      :alt="$t('period.alt.logo')" 
      :class="logoClasses"
    />
  </div>
</template>

<script>
/**
 * PageHeader Component
 * 
 * Reusable fixed header with logo and optional gradient blur effect.
 * 
 * Usage:
 *   <page-header />  // Default purple-50 with gradient
 *   <page-header background-color="moone-pink" />  // Custom Tailwind color
 *   <page-header background-color="white" />  // White background
 *   <page-header background-color="transparent" :with-gradient="false" />  // Transparent, no gradient
 * 
 * Available colors: purple-50, white, transparent, moone-transparent, moone-purple-30, 
 *                   moone-pink, moone-off-white, and all other custom Moone colors
 */
export default {
  name: 'PageHeader',
  
  props: {
    backgroundColor: {
      type: String,
      default: 'purple-50'
    },
    withGradient: {
      type: Boolean,
      default: true
    },
    logoSize: {
      type: String,
      default: 'w-20'
    },
    additionalClasses: {
      type: String,
      default: ''
    }
  },
  
  data() {
    return {
      colorMap: {
        // Tailwind default colors
        'purple-50': '#faf5ff',
        'white': '#ffffff',
        'transparent': 'transparent',
        
        // Custom Moone colors
        'moone-transparent': '#FAF5FF',
        'moone-purple': '#a855f7',
        'moone-light-purple': '#e9d5ff',
        'moone-purple-30': '#F5EAFE',
        'moone-pink': '#FAF4FE',
        'moone-off-white': '#FCFAFE',
        'moone-rose': '#fda4af',
        'moone-light-rose': '#ffe4e6',
        'moone-amber': '#f59e0b',
        'moone-light-amber': '#fed7aa',
        'moone-peach-light': '#fff1ec',
        'moone-peach': '#f8c3a0'
      }
    }
  },
  
  computed: {
    resolvedColor() {
      // If color is in the map, use it; otherwise, assume it's a direct hex/rgb value
      return this.colorMap[this.backgroundColor] || this.backgroundColor;
    },
    
    computedStyle() {
      if (this.withGradient) {
        return `background: linear-gradient(to bottom, ${this.resolvedColor} 0%, ${this.resolvedColor} 70%, transparent 100%)`;
      }
      return `background-color: ${this.resolvedColor}`;
    },
    
    logoClasses() {
      return `${this.logoSize} mt-4 mb-4 ${this.additionalClasses}`;
    }
  }
}
</script>

